// Copyright (c) 2020 Deere & Company

import './index.scss';
import React, {PropTypes} from 'react';
import Favorite from '@deere/cps-it.warranty-model-factory/lib/favorite';
import FavoritesList from './favorite-list';
import {FormattedMessage} from 'react-intl';

const Favorites = props =>
    <div className='favorites'>
        <h4 className='favorites-list-title'>
            <FormattedMessage id='FAVORITES'/>
        </h4>
        <FavoritesList
            favorites={props.favorites}
            handleFavoritesClick={props.onhandleFavoritesClick}
        />
    </div>;

Favorites.displayName = 'Favorites';
Favorites.propTypes = {
    favorites: PropTypes.arrayOf(PropTypes.instanceOf(Favorite)).isRequired,
    onhandleFavoritesClick: PropTypes.func.isRequired

};

export default Favorites;



// WEBPACK FOOTER //
// ./src/shared/components/favorites/index.js